import Components from "slotworks/components/components";
import AbstractBonus from "slotworks/state-machine/standard/states/abstract-bonus";
import Parallel from "slotworks/utils/contracts/parallel";
import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contracts/contract";
import Sequence from "slotworks/utils/contracts/sequence";
import substituteSymbols from "utils/substitute-symbols";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import reelsetModifier from "utils/reelset-modifier";
import changeMatrixCommand from "commands/change-matrix-command";
import attachMCSymbolCount from "utils/attach-mc-count-behaviour";
import { SetFreespinsBetbarCommand } from "slotworks/commands/betbar/set-freespins-betbar-command";
import { getTotalPicks, getCurrentPick } from "utils/calculate-picks-remaining";
import { Services } from "slotworks/services/services";
import gameState from "slotworks/model/game-state";
import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";
import { LLCustomLayers } from "../../../lib/luck-and-luxury/src/names";

export class CGMCBonusEnter extends AbstractBonus {

    public onEnter() {

        smartUiFlags.set(SmartUIFlag.FREE_SPINS, true);

        reelsetModifier.updateMCSymbolValues("multireel");
        substituteSymbols.withDarkSymbols();
        changeMatrixCommand.trigger("multireel");
        Components.matrix.maskIndividualSymbols();

        Components.footer.showMiscWin("bonus_reels");

        Services.sound.customEvent("fortune_blast_music");

        new Parallel([
            () => Layers.MatrixBackground.setScene("bonus"),
            () => Layers.MatrixForeground.setScene("bonus"),
            () => Contract.wrap(() => {
                attachMCSymbolCount.setupBehaviour();
                SetFreespinsBetbarCommand();

                if (this.currentSpinIsComplete()) {
                    Components.betBar.setTotalFreespins(3);
                    Components.betBar.setFreespinsPlayed(1);
                } else {
                    Components.betBar.setTotalFreespins(getTotalPicks());
                    Components.betBar.setFreespinsPlayed(getCurrentPick());
                }
                if (Layers.Background.hasScene("blast")) {
                    Layers.Background.setScene("blast").execute();
                }
                if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("blast")) {
                    Layers.Custom.get(LLCustomLayers.LOGOS).setScene("blast").execute();
                }
            })
        ]).then(() => {
            Services.sound.customEvent("fortune_blast_start");
            this.skip();
        });
    }

    public onExit() {
        // prevent bonus flag being disabled.
    }

    protected currentSpinIsComplete() {
        const currentHoldAndSpin = gameState.getCurrentGame().getCurrentRecord() as HoldAndSpinRecord;
        return currentHoldAndSpin.complete;
    }
}
